export default "__VITE_ASSET__B5knHQZZ__"